module.exports = __webpack_public_path__ + "static/img_onetoone_form@2x-9155f83c13ccbf17e63abab4af348907.png";